import "babel-polyfill";
import "url-search-params-polyfill";

import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";

Vue.config.productionTip = false;

import router from "./router";
import "@/assets/font/font.css";
import dialogBox from "@/components/dialog";
Vue.use(dialogBox);
import NotFoundImg from "@/assets/hok/yunyin.webp";
import VueLazyload from "vue-lazyload"; //引入这个懒加载插件
Vue.use(VueLazyload, {
  preLoad: 0.8,
  attempt: 1,
  loading: NotFoundImg,
  error: NotFoundImg,
});

if (!localStorage.getItem("com_flag")) {
  new Vue({
    router,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
}
